export const CONCEPT_ERROR_STATE = {
  INCONSISTENT_IMAGE: 'INCONSISTENT_IMAGE',
  INCONSISTENT_NAME: 'INCONSISTENT_NAME',
  MISSING_EITHER: 'MISSING_EITHER',
};

export const CONCEPT_ERROR_MESSAGES = {
  INCONSISTENT_IMAGE: 'Concept images must be provided for all quota groups if used.',
  INCONSISTENT_NAME: 'Concept names must be provided for all quota groups if used.',
  MISSING_EITHER:
    'All quota groups require either a concept image or name for a Monadic Concept Test survey.',
};

export const CUSTOMIZE_SAMPLE_FIELDS = [
  // People Group
  'people group',
  // Geography
  'user_census_region_name',
  'user_census_division_name',
  'user_urbanicity',
  'city',
  'postal_code',
  'user_state_name',
  // Demographic
  'age_bucket',
  'age_generation',
  'education',
  'employment',
  'ethnicity',
  'hispanic_acculturation',
  'hispanic_identification',
  'gender',
  'has_children',
  'has_children_ages_0_5',
  'has_children_ages_6_12',
  'has_children_ages_13_17',
  'hh_size',
  'income',
  'income_bucket_long',
  'marital_status',
  'home_language',
  'tv_language_preference',
  'lgbtq',
];

export const OPTIONAL_GEN_REP_FIELDS = [
  'basket_items__channel',
  'basket_items__dept',
  'basket_items__majorcat',
  'basket_items__parentchannel',
  'basket_items__sector',
  'basket_items__transaction_dt',
];
